import React, { useEffect, useRef, useState } from 'react';
import { highlightMatches } from './medicationSearch';

export function HighlightedText({ text, query }) {
  const parts = highlightMatches(text, query);
  return parts.map((part) =>
    part.mark ? (
      <mark key={part.key} className="cp-inv-med-mark">
        {part.text}
      </mark>
    ) : (
      <React.Fragment key={part.key}>{part.text}</React.Fragment>
    )
  );
}

/** Keyboard + open state for cp-smart-picker listboxes. */
export function useSmartPickerControls({ itemCount = 0, onPickIndex, disabled = false } = {}) {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const pickRef = useRef(onPickIndex);
  pickRef.current = onPickIndex;

  useEffect(() => {
    setActive(0);
  }, [itemCount]);

  const onKeyDown = (e) => {
    if (disabled) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setOpen(true);
      setActive((i) => Math.min(i + 1, Math.max(itemCount - 1, 0)));
      return;
    }
    if (e.key === 'ArrowUp') {
      e.preventDefault();
      setActive((i) => Math.max(i - 1, 0));
      return;
    }
    if (e.key === 'Enter' && open && itemCount > 0) {
      e.preventDefault();
      pickRef.current?.(active);
      setOpen(false);
      return;
    }
    if (e.key === 'Escape') setOpen(false);
  };

  return { open, setOpen, active, setActive, onKeyDown };
}
